module.exports = __webpack_public_path__ + "static/media/webchat.60e2377d.svg";